var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg042Bread1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 507.294 507.294",
    height: 512,
    viewBox: "0 0 507.294 507.294",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_25_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    d: "m485.155 38.411c-24.769-24.769-57.702-38.411-92.731-38.411s-67.962 13.642-92.731 38.411l-7.151 7.151v114.535h-30v-84.534l-57.803 57.803v114.534h-30v-84.534l-57.802 57.802v114.534h-30v-84.534l-48.525 48.525c-24.77 24.769-38.412 57.702-38.412 92.731s13.642 67.962 38.411 92.731c14.759 14.76 34.146 22.139 53.534 22.139 19.387 0 38.774-7.379 53.533-22.139l339.677-339.677c29.519-29.518 29.519-77.548 0-107.067z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg042Bread1);
export default __webpack_public_path__ + "static/media/042-bread-1.8aacbf01687c6a82743357c58d01363e.svg";
export { ForwardRef as ReactComponent };